module.exports = __webpack_public_path__ + "static/media/event-detail-white.c5bb1b2a.svg";